
import Vue from 'vue'
import IProductDecription from '@/types/ProductDecription'

export default Vue.extend({
  name: 'ProductDialog',
  props: {
    value: { type: Boolean, required: true },
    image: { type: String, default: '' },
    prodDesc: { type: Object as () => IProductDecription | null, default: null }
  },
  methods: {
    closeDialog () {
      this.$emit('input', false)
    }
  },
  computed: {
    show: {
      get (this: Vue & { value: boolean }) {
        return this.value
      },
      set (this: Vue & { value: boolean }, val: boolean) {
        this.$emit('input', val)
      }
    }
  }
}
)
